import {useTheme} from '@mui/material'
import {getProductLineColors} from '@progynyglobal/pg-ui-library'

import {useProductLine} from '@progyny/hooks/useProductLine'

export interface ProgressColor {
  main: string
  light: string
}

export const useProgressColor = (): ProgressColor => {
  const theme = useTheme()
  const {productLine} = useProductLine()
  const {primary} = getProductLineColors(productLine) as {primary: string}

  return {main: primary, light: theme.palette.neutral['50']}
}
